import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Config from '@/config'

Vue.use(Config)
Vue.use(Vuex)
Vue.use(VueAxios, axios)

axios.defaults.headers.common['Accept'] = 'application/json'
axios.defaults.withCredentials = true

export default new Vuex.Store({
    state: {
        mainSettings : {},
        games: [],
        providers: [],
        tipData:{},
        socialLinks:{},
        userData: null,
        messages: null,
        flashMessages: null,
        avilDepositMethods: null,
        avilWithdrawMethods: [],
        depositHistory:null,
        lastWithdrawHistory:null,
        withdrawHistory: {},
        winners: null,
        gameWinners: null,
        wheelStats: null,
        aliveGames: null,
        liveGames: null,
        balance: null,
        onHoldTransfers: null,
        onHoldTransfersAmount: null,
        userIdentityData : null,
        clientsLevel: null,
        uDepSum: null,
        bonuses: null,
        terms: null,
        enableWaitingWithdrawModal: 0,
        freeRound: null,
        freespins: null,
        slides : null,
        vipWithdrawalText: '',
        vipWithdrawalPercent: null,
        enabledRegistration: false,
    },
    actions: {
        fetchApiData(context) {
            axios.get(Config.baseUrl + '/Api/apiData', {crossdomain: true})
              .then((resp) => {
                  const apiData = resp.data.data.combinedData
                  context.commit('setClientsLevels',  apiData.levels)
                  context.commit('setuDepSum',  apiData.uDepSum)
                  context.commit('setMessages', apiData.messages)
                  context.commit('setWinnersList', apiData.winnersList)
                  context.commit('setAvilWithdrawMethods', apiData.withdrawMethods)
                  context.commit('setWithdrawHistory', apiData.withdraws)
                  context.commit('setAliveGames', apiData.aliveGames)
                  context.commit('setMainSettings', apiData.mainSettings)
                  context.commit('setDepositMethods', apiData.availableMethods)
                  context.commit('setFlashMessages', apiData.flashmessages)
                  context.commit('setBonuses', apiData.bonuses)
                  context.commit('setSlides', apiData.slides)
                  context.commit('setTerms', apiData.terms)
                  context.commit('setTipData', apiData.tipData)
                  context.commit('setSocialLinks', apiData.socialLinks)
                  context.commit('setEnableWaitingWithdrawModal', apiData.enableWaitingWithdrawModal)
                  context.commit('setEnabledRegistration', apiData.enabledRegistration)
                  context.commit('setFreespins', apiData.freespins)
                  context.commit('setVipWithdrawalText', apiData.vipWithdrawalsText)
                  context.commit('setVipWithdrawalPercent', apiData.vipWithdrawalsPercent)
              }).catch(err => {
                console.log(err.message)
            })
        },
        fetchLiveGames(context) {
            axios.get(Config.baseUrl + '/Api/getLiveLobbies', {crossdomain: true})
                .then((resp) => {
                    context.commit('setLiveGames', resp.data)
                }).catch(err => {
                console.log(err.message)
            })
        },
        getWithdrawHistory(context) {
            axios.get(
              Config.baseUrl + '/Api/withdrawHistory'
            ).then(({data}) => {
              if (data.status === 'ok') {
                if (data.data) {
                  context.commit('setLastWithdrawHistory', data.data.lastWithdraw)
                }
              }
            })
          },
          getDepositHistory(context) {
            axios.get(
              Config.baseUrl + '/Api/depositHistory'
            ).then(({data}) => {
              if (data.status === 'ok') {
                if (data.data) {
                  context.commit('setDepositHistory', data.data.lastDeposit)
      
                }
              }
            })
          },
        fetchUserData(context, update = false) {
            return new Promise((resolve) => {
                axios.get(
                    Config.baseUrl + '/Api/getUserInfo/' + update, {
                        crossdomain: true
                    }
                ).then(({data}) => {
                    if (data.data) {
                        let uData = null
                        if (data.data.id) {
                            uData = data.data
                            window.UserInfo = {'id': uData.id, 'login': uData.login}
                        }
                        context.commit('setUserData', uData)
                        resolve(data.data)
                    }
                })
            })
        },
        removeUserData(context) {
            context.commit('removeUserData')
        },
        fetchMessages(context) {
            try {
                axios.get(Config.baseUrl + '/Api/getMessages')
                    .then((resp) => {
                        context.commit('setMessages', resp.data.data)
                    }).catch(err => {
                    console.log(err.message)
                })
            } catch (err) {
                console.log(err.message)
            }
        },
        unsetFlashMessages(context) {
            axios.get(Config.baseUrl + '/Api/unsetFlashMessages'
            ).then(() => {
                context.commit('setFlashMessages', null)
            })
        },
        fetchGameWinners(context, data) {
            try {
                axios.get(Config.baseUrl + '/Api/getGameWinners/' + data['provider'] + '/' + data['gameId'])
                    .then((resp) => {
                        context.commit('setGameWinners', resp.data)
                    }).catch(err => {
                    console.log(err.message)
                })
            } catch (err) {
                console.log(err.message)
            }
        },
        getWheelStats(context) {
            try {
                axios.get(Config.baseUrl + '/Api/getWheelStats')
                    .then((resp) => {
                        context.commit('setWheelStats', resp.data)
                    }).catch(err => {
                    console.log(err.message)
                })
            } catch (err) {
                console.log(err.message)
            }
        },
        dispatchUserBalance (context, balance) {
            context.commit('setUserBalance', balance)
        },
        checkForAliveGame(context){
            axios.get(Config.baseUrl + '/Api/checkForAliveGame', {crossdomain: true})
              .then((resp) => {
                  context.commit('setAliveGames', resp.data.data.aliveGames)
              })
              .catch(err => {
                console.log(err.message)
            })
        },
        fetchOnHoldTransfers (context) {
            try {
                axios.get(Config.baseUrl + '/Api/getOnHoldTransactions')
                  .then((resp) => {
                      if (resp.data.data && resp.data.data.onHoldTransfers) {
                          context.commit('setOnHoldTransactions', resp.data.data.onHoldTransfers)
                      }
                  }).catch(err => {
                    console.log(err.message)
                })
            } catch (err) {
                console.log(err.message)
            }
        },
        fetchOnHoldTransfersAmount (context) {
            return new Promise((resolve) => {
                axios.get(
                  Config.baseUrl + '/Api/getOnHoldTransactions/onlyAmount',
                  {
                      crossdomain: true
                  }
                ).then(({ data }) => {
                    if (data.data) {
                        let response = data.data
                        context.commit('setOnHoldTransactionsAmount', response.onHoldTransfersAmount)
                        resolve(data.data)
                    }
                }) .catch(err => {
                    console.log(err)

                })
            })
        },
        fetchMainSettings(context) {
            axios.get(
              Config.baseUrl + '/Api/getMainSettings',
              {
                  crossdomain: true
              }
            ).then(({ data }) => {
                if (data.data) {
                    let response = data.data
                    context.commit('setMainSettings', response)
                }
            })
        },
        fetchUserIdentityData (context) {
            try {
                axios.get(Config.baseUrl + '/Api/getUserIdentityData')
                  .then((resp) => {
                      context.commit('setUserIdentityData', resp.data.data.identityData)
                  }).catch(err => {
                    console.log(err.message)
                })
            } catch (err) {
                console.log(err.message)
            }
        },

        fetchGames(context) {
            axios.get(Config.baseUrl + '/Api/gamesListv2', {crossdomain: true})
                .then((resp) => {
                  const answer = resp.data
                  if (answer.status && answer.status === 'ok') {
                    context.commit('setGames', answer.data)
                    context.commit('setProviders', answer.data)
                  }
                }).catch(err => {
              console.log(err.message)
            })
          },
      
          async fetchGamesByProvidersv2(context, provider) {
            try {
             await axios.post(
                  Config.baseUrl + '/Api/gamesListByProvidersv2',
                  {'provider': provider}
              ).then((resp) => {
                const answer = resp.data
                if(answer.status == "ok") {
                  context.commit('setGamesv2', answer.data)
                }
              }).catch(err => {
                console.log(err.message)
              })
            } catch (err) {
              console.log(err.message)
            }
          },
        checkUserFreeRound(context) {
            return new Promise((resolve) => {
                axios.get(
                    Config.baseUrl + '/Api/checkUserFreeRoundNew', {
                        crossdomain: true
                    }
                ).then(({data}) => {
                    if (data.data) {
                        context.commit('setFreeRound', data.data)
                        resolve(data.data)
                    }
                }).catch(err => {
                    console.log(err.message)
                })
            })
        },
    },

    mutations: {
        setBonuses(state, bonuses) {
            state.bonuses = bonuses
        },
        setTerms(state, terms) {
            state.terms = terms
        },
        setGames (state, data) {
            state.games = data.games
        },
        setGamesv2(state, data) {
            state.games[data.provider].games = data.games;
          },
          setProviders (state, data) {
            state.providers = data.providers
          },
        setLiveGames(state, games) {
            state.liveGames = games.data.tables
        },
        setUserData(state, user) {
            state.userData = user
        },
        removeUserData(state) {
            state.userData = null
        },
        setMessages(state, msgs) {
            state.messages = msgs
        },
        setFlashMessages(state, data) {
            state.flashMessages = data
        },
        setDepositMethods(state, methods) {
            state.avilDepositMethods = methods
        },
        setTipData (state, history) {
            state.tipData = history
        },
        setSocialLinks (state, socialLinks) {
            state.socialLinks = socialLinks
        },
        setEnableWaitingWithdrawModal (state, enableWaitingWithdrawModal) {
            state.enableWaitingWithdrawModal = enableWaitingWithdrawModal
        },
        setEnabledRegistration (state, enabledRegistration) {
            state.enabledRegistration = enabledRegistration
        },
        setAvilWithdrawMethods(state, withdrawMethods) {
            var x = {
                regular: [],
                vip: []
            };
            for(var i = 0; i < withdrawMethods.length; i++){
                if (withdrawMethods[i].is_vip == 0) {
                    x.regular.push(withdrawMethods[i]);
                } else {
                    x.vip.push(withdrawMethods[i]);
                }
            }
            state.avilWithdrawMethods = x;
        },
        setDepositHistory(state, depositHistory) {
            state.depositHistory = depositHistory
        },
        setLastWithdrawHistory(state, withdrawHistory) {
        state.lastWithdrawHistory = withdrawHistory
        },
        setWithdrawHistory(state, history) {
            state.withdrawHistory = history
        },
        setWinnersList(state, winners) {
            state.winners = winners
        },
        setGameWinners(state, winners) {
            state.gameWinners = winners.data['winners']
        },
        setWheelStats(state, stats) {
            state.wheelStats = stats.data
        },
        setUserBalance (state, balance) {
            state.balance = balance
        },
        setAliveGames(state, aliveGames){
            if (aliveGames) {
                state.aliveGames = aliveGames
            }
        },
        setOnHoldTransactions(state, data) {
            state.onHoldTransfers = data
        },
        setOnHoldTransactionsAmount(state, data) {
            state.onHoldTransfersAmount = data
        },
        setMainSettings(state, settings) {
            state.mainSettings = settings
        },
        setUserIdentityData(state, identityData) {
            state.userIdentityData = identityData
        },
        setClientsLevels (state ,levels) {
            Vue.set(state, 'clientsLevel', levels)
        },
        setuDepSum (state, uDepSum) {
            Vue.set(state, 'uDepSum', uDepSum)
        },
        setFreeRound(state, data) {
            if (data && data.id) {
                state.freeRound = data
            }else{
                state.freeRound = null
            }
        },
        setFreespins (state, freespins) {
            state.freespins = freespins
        },
        setVipWithdrawalText (state, text) {
            state.vipWithdrawalText = text
        },
        setVipWithdrawalPercent (state, text) {
            state.vipWithdrawalPercent = text
        },
        setSlides(state, slides) {
            state.slides = slides
        },
    },
    getters: {
        providers (state) {
        return state.providers
        },
        getMainSettings (state) {
            return state.mainSettings
        },
        games(state) {
            return state.games
        },
        liveGames(state) {
            return state.liveGames
        },
        userData(state) {
            if (state.userData) {
                return state.userData
            }
            return null
        },
        getMessages(state) {
            try {
                return state.messages
            } catch (err) {
                console.log(err.message)
            }
        },
        getDepositHistory(state) {
            try {
              return state.depositHistory
            } catch (err) {
              console.log(err.message)
            }
        },
        getLastWithdrawHistory(state) {
            try {
                return state.lastWithdrawHistory
            } catch (err) {
                console.log(err.message)
            }
        },
        getFlashMessages(state) {
            return state.flashMessages
        },
        getUnreadMessages(state, getters) {
            try {
                let msgs = []
                if (getters['getMessages'] != null) {
                    Object.values(getters['getMessages']).forEach((msg) => {
                        if (!msg.viewed) {
                            msgs.push(msg)
                        }
                    })
                }
                return msgs
            } catch (err) {
                console.log(err.message)
            }
        },
        getAvilDepositMethods(state) {
            try {
                return state.avilDepositMethods
            } catch (err) {
                console.log(err.message)
            }
        },
        getAvilWithdrawMethods(state) {
            try {
                return state.avilWithdrawMethods
            } catch (err) {
                console.log(err.message)
            }
        },
        getWithdrawHistory(state) {
            try {
                return state.withdrawHistory['withdraws']
            } catch (err) {
                console.log(err.message)
            }
        },
        getWinnersList(state) {
            return state.winners
        },
        getGameWinner(state) {
            return state.gameWinners
        },
        getWheelStats(state) {
            try {
                if (state.wheelStats !== null) {
                    let progressPercent = (state.wheelStats.profitBorder / 100) * state.wheelStats.lastMonthDeposit
                    state.wheelStats['progressPercent'] = parseInt(progressPercent)
                }
                return state.wheelStats
            } catch (e) {
                console.log(e.messages)
            }
        },
        aliveGames(state) {
            return state.aliveGames
        },
        getBalance(state) {
            return state.balance
        },
        getOnHoldTransactions (state) {
            return state.onHoldTransfers
        },
        getOnHoldTransactionsAmount (state) {
            return state.onHoldTransfersAmount
        },
        identityData (state) {
            return state.userIdentityData
        },
        clientsLevel (state) {
            return state.clientsLevel
        },
        uDepSum (state) {
            return state.uDepSum
        },
        getBonuses (state) {
            return state.bonuses
        },
        getTerms (state) {
            return state.terms
        },
        getTipData (state) {
            return state.tipData
        },
        getSocialLinks (state) {
            return state.socialLinks
        },
        getEnableWaitingWithdrawModal (state) {
            return state.enableWaitingWithdrawModal
        },
        freeRound(state) {
            return state.freeRound
        },
        getFreespins(state) {
            return state.freespins
        },
        getSlides (state) {
            return state.slides
        },
        getVipWithdrawalText (state) {
            return state.vipWithdrawalText
        },
        getVipWithdrawalPercent (state) {
            return state.vipWithdrawalPercent
        },
        getEnabledRegistration (state) {
            return state.enabledRegistration
        },
    }
})
